import { render, staticRenderFns } from "./ChatFab.vue?vue&type=template&id=3051a35d&scoped=true&"
import script from "./ChatFab.vue?vue&type=script&lang=js&"
export * from "./ChatFab.vue?vue&type=script&lang=js&"
import style0 from "./ChatFab.vue?vue&type=style&index=0&id=3051a35d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051a35d",
  null
  
)

export default component.exports